import { useInfiniteQuery } from "@tanstack/react-query";

import { InvitationRead } from "@/TS/Interfaces/global_interfaces";

interface InvitationsPageData {
  invitations: InvitationRead[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
}

interface UseInvitationsInfiniteQueryOptions {
  slug: string;
  pastDate?: boolean;
  itemsPerPage?: number;
  forUser?: string;
}

export function useInvitationsInfiniteQuery({
  slug,
  pastDate = false,
  itemsPerPage = 10,
  forUser,
}: UseInvitationsInfiniteQueryOptions) {
  return useInfiniteQuery<InvitationsPageData>({
    queryKey: [
      "club",
      slug,
      "invitations",
      pastDate ? "past" : "upcoming",
      forUser ?? "all",
    ],
    queryFn: async ({ pageParam }) => {
      const page = (pageParam as number) || 1;
      const params = new URLSearchParams({
        slug,
        page: page.toString(),
        itemsPerPage: itemsPerPage.toString(),
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...(pastDate && { past: "true" }),
        ...(forUser && { forUser }),
      });

      const response = await fetch(
        `/api/club-invitations?${params.toString()}`,
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error || "Erreur lors de la récupération des invitations",
        );
      }

      return response.json();
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.hasNextPage ? lastPage.currentPage + 1 : undefined;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
